import { createApp } from 'vue'
import { Button, DropdownMenu, DropdownItem, Tab, Tabs, Collapse, CollapseItem,Overlay  } from 'vant';
import App from './App.vue'
import vueSeamless from "vue-seamless-scroll/src";
import 'lib-flexible/flexible'
import './assets/style/common.css'
import i18n from './assets/i18n'
import axios from './assets/js/axios';

const app = createApp(App);
app.use(i18n);

app.use(Button);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Tab);
app.use(Tabs);
app.use(Collapse);
app.use(CollapseItem);
app.use(Overlay);
app.use(vueSeamless);

app.config.globalProperties.$axios = axios;

import Vconsole from 'vconsole'
const vConsole = new Vconsole()

app.mount('#app')
